/** Payouts page, payout drawer (approve / reject) and the New payout dialog. */
export const payouts = {
  title: "Payouts",
  intro: "Withdrawals to your players, from the API or created here. Large payouts wait for a second person to approve.",
  newPayout: "New payout",
  pausedTitle: "Payouts are paused",
  viewsLabel: "Payout views",
  tabAll: "All payouts",
  tabWaiting: "Waiting for approval",
  searchLabel: "Search request ID, player ref, username, address or tx hash",
  searchHint: "Player ref / username / request ID match from the start; paste a full address or tx hash.",
  tableCaption: "Payouts",
  /** Screen-reader label for a table row; {status} is the API status code. */
  rowLabel: "Payout {amount} {token}, {status}",
  cols: {
    created: "Created",
    playerRef: "Player ref",
    to: "To",
    amount: "Amount",
    fee: "Fee",
    txHash: "Tx hash",
  },
  byUser: "by {name}",
  viaApi: "via API",
  emptyWaitingTitle: "Nothing waiting for approval",
  emptyWaitingBody: "All caught up. Payouts above your approval threshold will appear here.",
  emptyNoMatch: "No payouts match",
  emptyNone: "No payouts yet",
  /** {hint} is searchHint. */
  emptyFilteredBody: "{hint} Try a wider date range or clear a filter.",
  emptyBody: "Payouts you create here or through the API show up in this list.",
  toastSubmitted: "Payout submitted. It's waiting for a second approver.",
  toastCreated: "Payout created and queued for sending",

  // 2FA code on approve / reject / create
  codeRequired: "Enter the 6-digit code from your authenticator app.",
  codeWrong: "That code didn't work. Wait for the next code and try again.",

  // Payout drawer
  drawer: {
    title: "Payout",
    failedTitle: "Payout failed",
    rejectedBy: "Rejected by {name}",
    aTeamMember: "a team member",
    waitingNote: "Waiting for an owner or finance member to approve this payout.",
    telegramNote: "Also sent to linked owners in Telegram.",
    needsApproval: "This payout needs approval",
    checkThenAct: "Check the address and amount, then approve or reject.",
    ownCantApprove: "You created it (or it came from your API key), so another approver has to approve it. You can still reject it.",
    cantApproveNow: "You can't approve this one right now (for example within 24 hours of joining, or while payouts are paused). You can still reject it.",
    approve: "Approve",
    reject: "Reject",
    approveConfirm: "Approve sending {amount} {token}?",
    rejectConfirm: "Reject this payout?",
    reason: "Reason",
    reasonPlaceholder: "e.g. Player account under review",
    reasonRequired: "Give a short reason. The team and the audit log will see it.",
    approvePayout: "Approve payout",
    rejectPayout: "Reject payout",
    approvedToast: "Payout approved and queued for sending",
    rejectedToast: "Payout rejected; the funds are back in your balance",
    viewOnExplorer: "View on block explorer",
  },

  // Detail rows (drawer and confirm step)
  d: {
    to: "To",
    amount: "Amount",
    fee: "Fee",
    playerReceives: "Player receives",
    totalFromBalance: "Total from balance",
    feeMode: "Fee mode",
    network: "Network",
    toAddress: "To address",
    txHash: "Tx hash",
    playerRef: "Player ref",
    createdBy: "Created by",
    approvedBy: "Approved by",
    rejectedBy: "Rejected by",
    created: "Created",
    completed: "Completed",
    requestId: "Request ID",
    payoutId: "Payout ID",
  },
  /** fee_mode API codes → labels; unknown codes show as they are. */
  feeModes: {
    on_top: "Added on top",
    deducted: "Deducted from amount",
  },

  // New payout dialog
  new: {
    title: "New payout",
    confirmTitle: "Confirm payout",
    description: "Send USDT or USDC from your balance to a player's wallet.",
    confirmDescription: "Check the details. Payouts can't be reversed once sent.",
    assetLabel: "Asset and network",
    loadingOption: "Loading…",
    noAssetsOption: "No networks enabled yet",
    tokenOnChain: "{token} on {chain}",
    /** {fee} is feeLine. */
    available: "Available: <b>{amount} {token}</b> · Fee {fee}",
    feeLine: "{pct}% (min {min} {token}), {mode}",
    feeLineSum: "{pct}% + {min} {token} network fee, {mode}",
    feeOnTop: "added on top of the amount",
    feeDeducted: "deducted from the amount",
    toLabel: "Player wallet address",
    toHint: "Double-check it: crypto sent to a wrong address can't be recovered.",
    /** {hint} is the address format, e.g. "T…" or "0x…". */
    toInvalid: "This doesn't look like a {chain} address ({hint}).",
    solanaAddress: "Solana address",
    amountLabel: "Amount",
    tooManyDecimals: "{token} on {chain} has at most {decimals} decimals.",
    notANumber: "Enter a number, e.g. 250.50",
    notPositive: "Enter an amount above zero.",
    playerRefLabel: "Player ref",
    feeLabel: "Fee",
    playerReceives: "Player receives",
    totalFromBalance: "Total from balance",
    calculating: "Calculating fee…",
    enterAmount: "Enter an amount to see the fee and total.",
    needsApprovalTitle: "Needs a second approval",
    needsApprovalBody: "Payouts of {amount} {token} or more wait for another owner or finance member to approve them before they are sent.",
    willWait: "This payout will wait for another approver before it is sent.",
    submitForApproval: "Submit for approval",
    sendPayout: "Send payout",
  },
};
